/**
 * Use the {@link makeDateOnly} function to create a new DateOnly.
 *
 * We wanted to create a primitive level of DateOnly that could be mapped from a string received from the backend.
 * This allows us to limit parameters to only allow DateOnly's even though they are strings.
 *
 * {@link DateOnlyRestriction} is not used at all. Read this stack overflow post to understand why it is here.
 *
 * https://stackoverflow.com/questions/61619809/typescript-how-to-disallow-two-type-aliases-that-resolve-to-the-same-type-to-b
 */
export type DateOnly = string & DateOnlyRestriction
type DateOnlyRestriction = { __brand: 'DateOnly' }

/**
 * Creates a DateOnly type representation of a string.
 *
 * See {@link DateOnly} for more details.
 *
 * @param s string to convert to a DateOnly
 */
export function makeDateOnly(s: string) {
	return s as DateOnly
}
